import clsx from "clsx";
import { useQueryState } from "nuqs";
import PropTypes from "prop-types";
import { useEffect, useMemo } from "react";

import { ProductTiles, Tab } from "@transfr-inc/dashboard-components";

import { isNullish } from "@lib/browser-utils";
import { productParser } from "@lib/utils/search-params-parsers";

import "./product.tab.scss";

export const ProductTab = ({
  name,
  className,
  displayProductTiles,
  productComponents,
}) => {
  const [selectedProductId, setSelectedProductId] = useQueryState(
    "product",
    productParser()
  );

  const productIds = useMemo(
    () =>
      Object.keys(productComponents)
        .filter((value) => !isNullish(value, true))
        .map((id) => Number(id)),
    [productComponents]
  );

  useEffect(() => {
    // If no product is selected, set the first product as the default
    if (productIds?.length > 0 && !productIds.includes(selectedProductId)) {
      setSelectedProductId(productIds[0]);
    }
  }, [productIds]);

  const productSelector = (displayProductTiles || productIds?.length > 1) && (
    <ProductTiles
      productIds={productIds}
      selectedProductId={selectedProductId}
      onProductSelect={setSelectedProductId}
    />
  );

  return (
    <Tab name={name} className={clsx(className, "product-tab")}>
      <div className="product-selector-container">{productSelector}</div>
      <div className="product-content-container">
        {productComponents[selectedProductId]}
      </div>
    </Tab>
  );
};

ProductTab.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  displayProductTiles: PropTypes.bool,
  productComponents: PropTypes.objectOf(PropTypes.node).isRequired,
};
